export const plans = [
  {
    group: 'Core Features',
    features: [
      {
        key: 'Monthly Emails',
        values: ['3x your contacts', '10x your contacts', '15x your contacts']
      },
      {
        key: 'Automation Flows',
        values: ['-', '-', 'Unlimited']
      },
      {
        key: 'Users',
        values: ['3 seats', '5 seats', 'Unlimited seats']
      },
      {
        key: 'Audiences',
        values: ['Unlimited', 'Unlimited', 'Unlimited']
      },
      {
        key: 'Custom Roles',
        values: ['-', '3 roles', 'Unlimited roles']
      },
      {
        key: 'SMS Credits',
        values: ['-', '-', 'Up to 50,000']
      },
      {
        key: 'Push Credits',
        values: ['-', '-', 'Up to 50,000']
      }
    ]
  },
  {
    group: 'Email Marketing',
    features: [
      {
        key: 'Drag & Drop Editor',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Mobile Optimization',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Go-Mailer branding',
        values: ['-', '-', '-']
      },
      {
        key: 'Email Scheduling',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Message Personalization',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Dedicated IP Addresses',
        values: ['-', '-', 'Yes']
      },
      {
        key: 'Email Testing',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Conversion Tracking',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Resend to Non-Openers',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Campaign Cloning',
        values: ['Yes', 'Yes', 'Yes']
      }
    ]
  },
  {
    group: 'Contact Management',
    features: [
      {
        key: 'Contact limit',
        values: ['50,000', '200,000', 'Unlimited']
      },
      {
        key: 'Tags',
        values: ['-', 'Yes', 'Yes']
      },
      {
        key: 'Segmentation',
        values: ['Basic', 'Advanced', 'Advanced']
      },
      {
        key: 'Custom Attribution',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Email Validation',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'List Clean-Up',
        values: ['-', 'Yes', 'Yes']
      },
      {
        key: 'API Synchronization',
        values: ['Yes', 'Yes', 'Yes']
      }
    ]
  },
  {
    group: 'Automations',
    features: [
      {
        key: 'Multi-channel',
        values: ['-', '-', 'Yes']
      },
      {
        key: 'Multiple starting points',
        values: ['-', '-', 'Yes']
      },
      {
        key: 'Conversion Tracking',
        values: ['-', '-', 'Yes']
      },
      {
        key: 'Exit Triggers',
        values: ['-', '-', 'Yes']
      }
    ]
  },
  {
    group: 'Analytics & Reporting',
    features: [
      {
        key: 'Basic reports',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Link Click Tracking',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Bounce Log Tracking',
        values: ['-', 'Yes', 'Yes']
      },
      {
        key: 'Delivery Log Tracking',
        values: ['-', 'Yes', 'Yes']
      },
      {
        key: 'Demographic reports',
        values: ['-', 'Yes', 'Yes']
      },
      {
        key: 'Comparative reports',
        values: ['-', 'Yes', 'Yes']
      },
      {
        key: 'Data retention',
        values: ['14 days', '30 days', '90 days']
      }
    ]
  },
  {
    group: 'Analytics & Reporting',
    features: [
      {
        key: 'Basic reports',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Link Click Tracking',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Bounce Log Tracking',
        values: ['Basic', 'Advanced', 'Advanced']
      },
      {
        key: 'Delivery Log Tracking',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Demographic reports',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Comparative reports',
        values: ['-', 'Yes', 'Yes']
      },
      {
        key: 'Data retention',
        values: ['14 days', '30 days', '90 days']
      }
    ]
  },
  {
    group: 'Support Services',
    features: [
      {
        key: 'Customer Support',
        values: ['Email & Chat', 'Phone, Email & Chat', 'Phone, Email & Chat']
      },
      {
        key: 'Guides and Tutorials',
        values: ['Yes', 'Yes', 'Yes']
      },
      {
        key: 'Dedicated Manager',
        values: ['-', '-', 'Yes']
      },
      {
        key: 'Personalized Onboarding',
        values: ['1 Session', '3 Sessions', '5 Sessions']
      }
    ]
  }
];
